module.exports = __webpack_public_path__ + "7b8c70193db784d6fac9deab35ebe536.svg";